import React, { Component } from "react";
import _ from "lodash";
import Button from "../base-components/button"
import { sendAPIRequest } from "shared/utils/requests";

class SiteVideo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      transition: false,
    };

  }

  static getDerivedStateFromProps(props, state) {

    return null;
  }

  componentDidMount = () => {
  }

  componentDidUpdate(_, prevState) {
    
  }

  componentWillUnmount() {
  }

  submitVideo() {
    this.setState({ transition: true })
  }

  async nextStep() {
    const {
      updateOnboardingStep,
    } = this.props;

    const response = await sendAPIRequest(`/onboarding/submit_video`, "POST", { });
    if (response.data.status == 'success') {
      updateOnboardingStep(response.data.onboardingStep);
    } else {
      throw new Error("invalid status for video submission: " + response.data.status)
    }
  }

  render() {
    const {
      currentContractor,
    } = this.props;

    const {
      transition,
    } = this.state;

    if (transition) {
      return (
        <div className="onboarding-transition-container">
          <div className="onboarding-transition-icon">
            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.6776 2.80646L6.49614 13.9355L2.32275 8.87684" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="onboarding-title onboarding-transition-title">
            Account Setup Complete!
          </div>
          <div className="onboarding-transition-body">
            <div className="onboarding-biglabel onboarding-transition-head">
              By now you should have:
            </div>
            <div className="onboarding-biglabel onboarding-biglabel-dark">
              - Reviewed our NDA and Privacy Policy
            </div>
            <div className="onboarding-biglabel onboarding-biglabel-dark">
              - Linked your PayPal account
            </div>
            <div className="onboarding-biglabel onboarding-biglabel-dark">
              - Set up Slack
            </div>
            <div className="onboarding-biglabel onboarding-biglabel-dark">
              - Have a general understanding of how the site works
            </div>
          </div>
          <div className="onboarding-biglabel onboarding-transition-trailer">
            You are ready to begin training and review our transcription <br />
            guidelines so that you can start working
          </div>
          <div className="onboarding-transition-submission">
            <Button className="onboarding-submission-button" onClick={() => this.nextStep()} text="Begin Training" />
          </div>
        </div>
      );
    } else {
      return (
        <div className="onboarding-video-container">
          <div className="onboarding-title">
            Watch a Site Explanation Video
          </div>
          <div className="onboarding-biglabel onboarding-paypal-subtitle">
            Please watch this short video about how our site works!
          </div>
          <iframe width="720" height="315" src="https://www.youtube.com/embed/ML3fND53ClA" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullscreen />
          <div className="onboarding-divider"/>
          <div className="onboarding-submission">
            <Button className="onboarding-submission-button" onClick={() => this.submitVideo()} text="Complete Account Setup" />
          </div>
        </div>
      );
    }
  }

}

export default SiteVideo;
